import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { v4 as uuidv4 } from "uuid";


const Db_faq = () => {
    const webDevelopmentFAQs = [
        {
          "id": uuidv4(),
          "question": "What is the significance of database migration and modernization?",
          "answer": "Database migration and modernization are crucial processes that involve transferring data from one system to another, often to newer technologies or cloud-based platforms. This ensures enhanced performance, improved security, and scalability to meet evolving business needs."
        },
        {
          "id": uuidv4(),
          "question": "How do I know if my organization needs database migration services?",
          "answer": "Signs that indicate the need for migration include outdated hardware, poor system performance, increased downtime, or the desire to leverage cloud capabilities. If your database struggles to keep up with business demands, migration and modernization may be necessary."
        },
        {
          "id": uuidv4(),
          "question": "How long does the database migration and modernization process typically take?",
          "answer": "The duration varies based on factors such as the size of the database, complexity of the data structures, and the chosen migration approach. A well-planned migration strategy can help minimize downtime and streamline the process."
        },
        {
          "id": uuidv4(),
          "question": "What are the potential challenges during the migration process?",
          "answer": "Common challenges include data integrity issues, application compatibility, and potential downtime during the migration. A thorough assessment and strategic planning are essential to mitigate these challenges and ensure a smooth transition."
        },
        {
          "id": uuidv4(),
          "question": "What security measures are in place during the migration process to protect sensitive data?",
          "answer": "Security is a top priority during database migration. Encryption, secure data transfer protocols, and access controls are implemented to safeguard sensitive information. Comprehensive planning includes risk assessments and compliance with data protection regulations."
        }
      ]
      return (
        <div className='px-5 sm:px-60 mt-10' id="faq">
          <p className='text-[#333e49] text-center font-notosans text-2xl sm:text-4xl font-bold m-10'>Frequently Asked Questions</p>
          {
            webDevelopmentFAQs.map((item) => 
        <Accordion key={item.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className='font-notosans font-bold'
          >
            {item.question}
          </AccordionSummary>
          <AccordionDetails className='font-notosans'>
            {item.answer}
          </AccordionDetails>
        </Accordion>
            )
          }
      </div>
      )
}

export default Db_faq